
export enum ShowClientLoyaltyBalanceType {
  ShowNumberOfPointsOnly = 1,
  ShowNumberOfPointsAndItsEquivalentBalance
}
